import { render } from "./Group-Select.vue?vue&type=template&id=5da21836"
import script from "./Group-Select.vue?vue&type=script&lang=js"
export * from "./Group-Select.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__